import { type FC } from "react";
import EngagementOverviewTabs from "../components/Tabs/EngagementOverviewTabs";
import "../components/Tabs/EngagementOverviewTabs.scss";

const EngagementOverviewDashboard: FC = () => (
  <div className="engagement-overview-dashboard-with-data engagement-overview-dashboard-with-data--viewport-bound">
    <EngagementOverviewTabs />
  </div>
);

export default EngagementOverviewDashboard;
